import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          setError(error.message);
          // Redirect to home with error after a delay
          setTimeout(() => navigate('/?auth=error'), 2000);
          return;
        }

        if (data.session) {
          console.log('Auth callback successful:', data.session.user.email);
          // Redirect to home with success
          navigate('/?auth=success');
        } else {
          // No session found, redirect to home
          navigate('/');
        }
      } catch (err) {
        console.error('Unexpected auth callback error:', err);
        setError('An unexpected error occurred during authentication.');
        setTimeout(() => navigate('/?auth=error'), 2000);
      } finally {
        setLoading(false);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-banana-50 to-yellow-100">
        <div className="text-center">
          <div className="animate-bounce text-6xl mb-4">🍌</div>
          <h2 className="text-2xl font-bold text-banana-800 mb-2">Almost there!</h2>
          <p className="text-banana-600">Completing your sign in...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-banana-50 to-yellow-100">
        <div className="text-center">
          <div className="text-6xl mb-4">😕</div>
          <h2 className="text-2xl font-bold text-red-800 mb-2">Sign In Failed</h2>
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-gray-600">Redirecting you back...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-banana-50 to-yellow-100">
      <div className="text-center">
        <div className="text-6xl mb-4">✅</div>
        <h2 className="text-2xl font-bold text-green-800 mb-2">Success!</h2>
        <p className="text-green-600">Redirecting you to the game...</p>
      </div>
    </div>
  );
}; 